import axios from 'axios'
import { CSRF_TOKEN } from './helpers'

const requestWithCSRF = (options = {}) => {
  return axios({
    ...options,
    data: {
      ...(options.data || {}),
      authenticity_token: CSRF_TOKEN
    }
  })
}

export const textModerationDelete = ({ id, ...data  }) => {
  return requestWithCSRF({
    url: `/${gon.currentProvider}/api/text_moderations/${id}`,
    method: 'delete',
    data,
  })
}

export const textModerationIgnore = ({ id, ...data }) => {
  return requestWithCSRF({
    url: `/${gon.currentProvider}/api/text_moderations/${id}/ignore`,
    method: 'post',
    data,
  })
}

export const textModerationBan = ({ id, ...data }) => {
  return requestWithCSRF({
    url: `/${gon.currentProvider}/api/text_moderations/${id}/ban`,
    method: 'post',
    data,
  })
}

export const textModerationBulkUpdate = (tasks = [], action) => {
  return requestWithCSRF({
    url: `/${gon.currentProvider}/api/bulk/text_moderations`,
    method: 'post',
    data: {
      tasks: JSON.stringify(tasks),
      action
    }
  })
}

export const createBannedWord = (word, banType) => {
  return requestWithCSRF({
    url: `/${gon.currentProvider}/api/banned_words`,
    method: 'post',
    data: {
      word,
      ban_type: banType,
    }
  })
}

export const createUrlInspector = (entry, banType) => {
  return requestWithCSRF({
    url: `/${gon.currentProvider}/api/url_inspectors`,
    method: 'post',
    data: {
      entry,
      ban_type: banType
    }
  })
}

export const createTrustedDomain = (domain) => {
  return requestWithCSRF({
    url: `/${gon.currentProvider}/api/trusted_domains`,
    method: 'post',
    data: { domain }
  })
}
